import styled, { css } from 'styled-components';
export const PopoverElement = styled.div(({ theme }) => css `
    max-width: ${theme.styles.select.control.maxWidth};
  `);
//# sourceMappingURL=popover.styles.js.map